


























































import { Component, Prop, Vue } from "vue-property-decorator";
import * as moment from "moment";
import { PostsApi } from "../../../apis";
@Component({
  components: {},
})
export default class License extends Vue {
  content = "";
  createdBy = null;
  createdAt = null;
  lastEditedBy = null;
  updatedAt = null;
  headerImageHeight = "100%";
  onEdit() {
    return this.$router.push({ name: "edit-license" });
  }
  mounted() {
    this.getAbout();
  }

  get isEn() {
    return this.$store.getters.locale === "en";
  }

  get isVi() {
    return this.$store.getters.locale === "vi";
  }

  async getAbout() {
    try {
      this.$util.showLoading();
      const res = await new PostsApi().getLicensePost();
      const [licenseData] = res.data.data;
      this.content = this.isEn ? licenseData.contentEn : licenseData.contentVn;
      this.createdBy = !licenseData.createdBy
        ? ""
        : licenseData.createdBy.fullName;
      this.createdAt = licenseData.createdAt;
      this.lastEditedBy = !licenseData.updatedBy
        ? ""
        : licenseData.updatedBy.fullName;
      this.updatedAt = licenseData.updatedAt;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }
}
